export const environment = {
    production: false,
    pieAPIUrl: 'https://internalapi.pie.subprod.toyota.com',
    hcmDsUrl: 'https://dev.ds.hcm-app.toyota.com/dataservice',
    // hcmDsUrl: 'http://localhost:8080/dataservice',
    pieTokenUrl: 'https://0yxutz0mfk.execute-api.us-west-2.amazonaws.com/dev',
    ssoredirectUri: 'https://dev-lineside.hcm-app.toyota.com/'
    // ssoredirectUri: 'http://localhost:4200',
  };
  